module.exports = __webpack_public_path__ + "img/logo.f3b45c31.png";